import { render, staticRenderFns } from "./Aydinlatma.vue?vue&type=template&id=68501bc0&scoped=true&"
import script from "./Aydinlatma.vue?vue&type=script&lang=js&"
export * from "./Aydinlatma.vue?vue&type=script&lang=js&"
import style0 from "./Aydinlatma.vue?vue&type=style&index=0&id=68501bc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68501bc0",
  null
  
)

export default component.exports